module.exports = __webpack_public_path__ + "img/discord.8ab0efc2.svg";